import CryptoJS from 'crypto-js';

/**
 * Mirrors Laravel EncryptionHelper::decrypt (AES-256-CBC, OPENSSL_RAW_DATA).
 * Payload: ivBase64 + ":" + encryptedDataBase64 (both segments base64-encoded raw bytes).
 * Key: first 32 characters of SECRET_KEY (same as PHP Str::substr($secretKey, 0, 32)).
 *
 * Set REACT_APP_SECRET_KEY to the same value as backend SECRET_KEY (min 32 chars).
 */
function decryptAes256CbcPayload(trimmedBody, secretKey) {
    const keyStr = String(secretKey).substring(0, 32);
    if (keyStr.length < 32) {
        throw new Error('REACT_APP_SECRET_KEY must be at least 32 characters');
    }
    const colon = trimmedBody.indexOf(':');
    if (colon < 1) {
        throw new Error('Invalid encrypted payload (expected ivBase64:encryptedDataBase64)');
    }
    const ivBase64 = trimmedBody.slice(0, colon);
    const encryptedDataBase64 = trimmedBody.slice(colon + 1);
    const iv = CryptoJS.enc.Base64.parse(ivBase64);
    const ciphertext = CryptoJS.enc.Base64.parse(encryptedDataBase64);
    const key = CryptoJS.enc.Utf8.parse(keyStr);
    const decrypted = CryptoJS.AES.decrypt(
        CryptoJS.lib.CipherParams.create({ ciphertext }),
        key,
        { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );
    const plain = decrypted.toString(CryptoJS.enc.Utf8);
    if (!plain) {
        throw new Error('Decryption failed');
    }
    return JSON.parse(plain);
}

/**
 * Read fetch Response body: supports plain JSON (dev) and encrypted iv:cipher strings (prod).
 * Drop-in replacement for response.json() on encrypted API routes.
 */
export async function readEncryptedJsonResponse(response) {
    const text = await response.text();
    const trimmed = text.trim();
    if (!trimmed) {
        throw new Error('Empty API response body');
    }
    try {
        return JSON.parse(trimmed);
    } catch (_) {
        /* not JSON — assume AES wrapper */
    }
    const secret = process.env.REACT_APP_SECRET_KEY;
    if (!secret) {
        throw new Error('REACT_APP_SECRET_KEY is required for encrypted API responses');
    }
    return decryptAes256CbcPayload(trimmed, secret);
}
